module.exports = function () {
    const languageSelector = document.querySelector(
        ".language-selector__dropdown"
    );

    if (!languageSelector) return;
    
    const languageSelectorButton = languageSelector.querySelector("button");
    const languageSelectorList = languageSelector.querySelector("ul");
    const languageSelectorOptions = languageSelector.querySelectorAll("li");

    const openLanguageSelector = () => {
        languageSelectorButton.setAttribute("aria-expanded", "true");
        languageSelectorList.focus();
    };

    const closeLanguageSelector = () => {
        languageSelectorButton.setAttribute("aria-expanded", "false");
        languageSelectorButton.focus();
    };

    const handleClick = () => {
        if (languageSelectorButton.getAttribute("aria-expanded") === "false") {
            openLanguageSelector();
        } else {
            closeLanguageSelector();
        }
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 27) {
            e.preventDefault();
            closeLanguageSelector();
        }
    };

    const handleClickOutside = (e) => {
        const targetEl = e.target;

        if (
            targetEl !== languageSelector &&
            !languageSelector.contains(targetEl) &&
            languageSelectorButton.getAttribute("aria-expanded") === "true"
        ) {
            languageSelectorButton.setAttribute("aria-expanded", "false");
        }
    };

    const handleOptionClick = (e) => {
        window.location.href = e.target.dataset.url;
    };

    document.addEventListener("click", handleClickOutside);
    languageSelectorButton.addEventListener("click", handleClick);
    languageSelectorList.addEventListener("keydown", handleKeyDown);

    languageSelectorOptions.forEach((option) =>
        option.addEventListener("click", handleOptionClick)
    );
};
